module.exports = __webpack_public_path__ + "static/img/logo.4e7770c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/bodyfriend/logo.png
// module id = uwuW
// module chunks = 1